import type { TranslationDictionary } from '../data/types';
import { generatedHotspotLabelsVi } from './generated/hotspot-labels';
import { generatedSceneLabelsVi } from './generated/scene-labels';

const vi: TranslationDictionary = {
  ui: {
    ...generatedHotspotLabelsVi,
    'app.eyebrow': 'Khu Y tế Kỹ thuật cao',
    'app.title': 'Tham quan 360°',
    'app.subtitle': 'Khám phá Bệnh viện Quốc tế City & Bệnh viện Gia An 115 từ mọi góc nhìn.',
    'app.startTour': 'Bắt đầu tour',
    'app.suggestedJourneys': 'Hành trình gợi ý',
    'app.sceneList': 'Danh sách cảnh',
    'app.booking': 'Đặt lịch khám',
    'app.hotline': 'Gọi hotline',
    'app.backToWebsite': 'Về website chính',
    'app.fullscreen': 'Toàn màn hình',
    'app.exitFullscreen': 'Thoát toàn màn hình',
    'app.gyro': 'Gyroscope',
    'app.loading': 'Đang tải panorama…',
    'app.close': 'Đóng',
    'app.currentScene': 'Đang xem',
    'app.viewControls': 'Điều khiển xem',
    'app.zoomIn': 'Phóng to',
    'app.zoomOut': 'Thu nhỏ',
    'app.autorotateStart': 'Tự động xoay',
    'app.autorotateStop': 'Dừng tự động xoay',
    'app.resetView': 'Về góc nhìn ban đầu',
    'app.autoTourStart': 'Tự động tham quan',
    'app.autoTourStop': 'Dừng tự động tham quan',
    'app.lookUp': 'Nhìn lên',
    'app.lookDown': 'Nhìn xuống',
    'app.lookLeft': 'Xoay trái',
    'app.lookRight': 'Xoay phải',
    'app.focusView': 'Tập trung xem',
    'app.hideToolbar': 'Ẩn thanh menu',
    'app.hideControls': 'Ẩn điều khiển',
    'app.showControls': 'Hiện điều khiển',
    'app.showUi': 'Hiện menu',
    'app.lang.vi': 'VI',
    'app.lang.en': 'EN',
  },
  groups: {
    'groups.overview': 'Toàn cảnh/Flycam',
    'groups.cih': 'Bệnh viện quốc tế City (CIH)',
    'groups.gia-an': 'Bệnh viện Gia An 115',
  },
  scenes: {
    ...generatedSceneLabelsVi,
  },
  journeys: {
    'journeys.investor.label': 'Nhà đầu tư / Đối tác',
    'journeys.investor.description':
      'Flycam toàn khu → Chào mừng → Sảnh CIH & Gia An → Cấp cứu, CĐHA, Phòng mổ, Lim Premier',
    'journeys.patient-cih.label': 'Bệnh nhân lần đầu — CIH',
    'journeys.patient-cih.description': 'Sảnh → Tiếp nhận → Phòng chờ → Khám ngoại trú → Nội trú / VIP',
    'journeys.specialist-ga.label': 'Khám chuyên sâu — Gia An',
    'journeys.specialist-ga.description':
      'Sảnh → Khám bệnh → CĐHA → Phòng mổ / VLTL → Lim Premier → Phòng tiêu biểu',
  },
};

export default vi;
